
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XHeader
},
data () {
return {
}
},
created() {
},
methods: {
}
}



// WEBPACK FOOTER //
// ./src/components/About.vue